import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M20 19V14.92H22V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19V14.99H4V19H20ZM18.25 9.72L16.83 8.3L13.01 12.11V3H11V12.11L7.18 8.3L5.76 9.72L12.01 15.96L18.26 9.72H18.25Z" fill={ fill || 'currentColor' } />
    </svg>
);
